import { render, staticRenderFns } from "./essay_tab_plagiarism.vue?vue&type=template&id=1917d007&scoped=true&"
import script from "./essay_tab_plagiarism.vue?vue&type=script&lang=js&"
export * from "./essay_tab_plagiarism.vue?vue&type=script&lang=js&"
import style0 from "./essay_tab_plagiarism.vue?vue&type=style&index=0&id=1917d007&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1917d007",
  null
  
)

export default component.exports